<template>
    <v-flex>
        
        <v-layout row class="content-header">
            <v-flex md6 class="content-title">
            </v-flex>
            <v-flex md5>
                <v-text-field v-model="search" label="Pesquisa" placeholder="Nome..." outlined class="input-pesquisa"></v-text-field>
            </v-flex>
            <v-flex md-1 class="text-right">
                <v-btn color="info" @click="novoMembro()"><v-icon>add</v-icon></v-btn>
            </v-flex>
            <v-flex md12>
                <div class="line"></div>
            </v-flex>
        </v-layout>

        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-data-table
                    :headers="headers"
                    :items="membros"
                    :items-per-page="topItems"
                    :options.sync="options"
                    :loading="loading"
                    :search="search"
                    loading-text="Carregando... Por favor aguarde."
                    no-data-text="Nenhuma informação encontrada"
                    no-results-text="Nenhuma informação encontrada"   
                    :sort-by="['Email']"
                    :sort-asc="[true]"                                
                    class="">
                    <template v-slot:item.painelNegocios="{ item }" align="center">
                        <v-checkbox v-model="item.painelNegocios.active" @change="alterarRoleClaim(item.painelNegocios, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.produtosPrevisul="{ item }" align="center">
                        <v-checkbox v-model="item.produtosPrevisul.active" @change="alterarRoleClaim(item.produtosPrevisul, item.id)"></v-checkbox>
                    </template>                
                    <template v-slot:item.cotaMais="{ item }" align="center">
                        <v-checkbox v-model="item.cotaMais.active" @change="alterarRoleClaim(item.cotaMais, item.id)"></v-checkbox>
                    </template>  
                    <template v-slot:item.movVidas="{ item }" align="center">
                        <v-checkbox v-model="item.movVidas.active" @change="alterarRoleClaim(item.movVidas, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.arquivosDfi="{ item }" align="center">
                        <v-checkbox v-model="item.arquivosDfi.active" @change="alterarRoleClaim(item.arquivosDfi, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.arquivosSqg="{ item }" align="center">
                        <v-checkbox v-model="item.arquivosSqg.active" @change="alterarRoleClaim(item.arquivosSqg, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.arquivosPrestamista="{ item }" align="center">
                        <v-checkbox v-model="item.arquivosPrestamista.active" @change="alterarRoleClaim(item.arquivosPrestamista, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.segundaVia="{ item }">
                        <v-checkbox v-model="item.segundaVia.active" @change="alterarRoleClaim(item.segundaVia, item.id)"></v-checkbox>
                    </template>                 
                    <template v-slot:item.relatorios="{ item }">
                        <v-checkbox v-model="item.relatorios.active" @change="alterarRoleClaim(item.relatorios, item.id)"></v-checkbox>
                    </template>                                  
                    <template v-slot:item.sinistro="{ item }" align="center">
                        <v-checkbox v-model="item.sinistro.active" @change="alterarRoleClaim(item.sinistro, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.ajuda="{ item }" align="center">
                    <v-checkbox v-model="item.ajuda.active" @change="alterarRoleClaim(item.ajuda, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.informesFiscais="{ item }" align="center">
                        <v-checkbox v-model="item.informesFiscais.active" @change="alterarRoleClaim(item.informesFiscais, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.comissoes="{ item }" align="center">
                        <v-checkbox v-model="item.comissoes.active" @change="alterarRoleClaim(item.comissoes, item.id)"></v-checkbox>
                    </template>               
                    
                    <template v-slot:item.souMaisPrevisul="{ item }" align="center">
                        <v-checkbox v-model="item.souMaisPrevisul.active" @change="alterarRoleClaim(item.souMaisPrevisul, item.id)"></v-checkbox>
                    </template>
                    <template v-slot:item.processosJudiciais="{ item }" align="center">
                        <v-checkbox v-model="item.processosJudiciais.active" @change="alterarRoleClaim(item.processosJudiciais, item.id)"></v-checkbox>
                    </template>                                                                               
                    <template v-slot:item.opcoes="{ item }">
                        <v-hover v-slot:default="{ hover }" title="Bloquear" v-if="item.active == true">
                            <v-icon v-on:click="dialogInativarMembro(item)"  class="hover" color="green">mdi-checkbox-marked-circle</v-icon>
                        </v-hover>
                        <v-hover v-slot:default="{ hover }" title="Desbloquear" v-if="item.active == false">
                            <v-icon v-on:click="dialogAtivarMembro(item)" class="hover" color="red">lock</v-icon>
                        </v-hover>
                        <v-hover v-slot:default="{ hover }" title="Editar">
                            <v-icon v-on:click="detalhesMembro(item)" class="hover">edit</v-icon>
                        </v-hover>                    
                    </template>                
                </v-data-table>
            </v-flex>

            <v-overlay :value="fullLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-dialog v-model="dialog" :max-width="dialogMaxWidth">
                <v-card v-if="dialogCardTexto">
                    <v-card-title class="headline">{{ this.tituloDialog }}</v-card-title>
                    <v-card-text>
                    {{ this.textoDialog }}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1"  v-if="botaoCancelar" text @click="dialog = false">Cancelar</v-btn>
                        <v-btn v-if="botaoInativar" color="green darken-1" text @click="alterarStatusMembro(false)">Ok</v-btn>       
                        <v-btn v-if="botaoAtivar" color="green darken-1" text @click="alterarStatusMembro(true)">Ok</v-btn>
                        <v-btn v-if="botaoConcederAcesso" color="green darken-1" text @click="concederAcesso()">Sim</v-btn> 
                    </v-card-actions>
                </v-card>
                <v-card v-if="dialogCardMembro">
                    <v-overlay :value="fullLoading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>                    
                    <v-form @submit.prevent="ColaboradorExiste('formCollaborator')" data-vv-scope="formCollaborator" ref="formCollaborator" >
                        <v-card-title class="headline">{{ this.tituloDialog }}</v-card-title>
                        <v-card-text>
                            
                                <div class="flex-row mt-12">
                                    <div class="flex-col-12">
                                        <div class="flex-row">
                                            <div class="flex-col-8">
                                                <v-text-field label="Nome Completo" v-model="membro.name" :rules="[rules.required]" tabindex="1" :readonly="membro.personId !== undefined" outlined></v-text-field>
                                            </div>
                                            <div class="flex-col-1">
                                            </div>
                                            <div class="flex-col-3">
                                                <v-radio-group v-model="membro.sex" row class=" mt-0" :rules="[rules.required]" tabindex="2">
                                                    <v-radio label="Masculino" value="M"></v-radio>
                                                    <v-radio label="Feminino" value="F"></v-radio>
                                                </v-radio-group>
                                            </div>
                                        </div>

                                        <div class="flex-row">
                                            <div class="flex-col-3">
                                                <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-model="membro.dataNasc" @blur="date = parseDate(membro.dataNasc)"  v-mask="'##/##/####'" label="Nascimento" v-on="on" :rules="[rules.required]" tabindex="3" outlined></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
                                                </v-menu>                    
                                            </div>
                                            <div class="flex-col-5">
                                                <v-text-field label="CPF" v-model="membro.register" v-mask="CPFMask" :rules="[rules.required, rules.CPFValido]" tabindex="4" :readonly="membro.personId !== undefined" outlined></v-text-field>
                                            </div>
                                        </div>

                                        <div class="flex-row">
                                            <div class="flex-col-8">
                                                <v-text-field label="E-mail comercial" type="email" v-model="membro.email" :rules="[rules.required, rules.mailAddress]" tabindex="5" :readonly="membro.personId !== undefined" outlined></v-text-field>
                                            </div>
                                            <div class="flex-col-4">
                                                <v-text-field label="Telefone" v-model="membro.phoneContact" v-mask="telefoneMask" :rules="[rules.required, rules.celularValido]" tabindex="6" outlined @input="AtualizarMascaraTelefone()"></v-text-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                     

                                <div class="flex-row">
                                    <div class="flex-col-12"> <!-- MENSAGENS -->
                                        <v-row>
                                            <v-col cols="12" sm="12">
                                                <h2>Corretor,<br>
                                                Caso você deseje que este colaborador receba de forma automática, via What’sApp, informações da Previsul, selecione abaixo:</h2>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="4">
                                                <v-switch
                                                v-model="dadosEnvioMensagens.receberEmissaoApolice"
                                                label="Emissões de Apólice"
                                                ></v-switch>
                                            </v-col>
                                        </v-row>

                                    </div>
                                </div>                                     

                        </v-card-text> 
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="limparDialog()"><v-icon>cancel</v-icon>&nbsp; Cancelar</v-btn>
                            <v-btn :disabled="botaoLimpar" color="error" type="reset" text><v-icon>clear</v-icon>&nbsp; Limpar</v-btn>  
                            <v-btn color="info" type="submit" text tabindex="14"><v-icon>check</v-icon>&nbsp; Salvar</v-btn>  
                        </v-card-actions>                           
                    </v-form>                     
                </v-card>
            </v-dialog>
        </v-layout>
    </v-flex>
</template>

<script>

    import Vue from 'vue';
    import moment from 'moment';
    import { mask } from 'vue-the-mask';
    import Helpers from "@/utilities/Helpers";
    import { mapGetters } from "vuex"; 

    export default {
        mixins: [Helpers],
        directives: { mask, },         
        data() {
            return {
                search: "",
                termoPesquisa: "",
                loading: true,
                fullLoading: false,
                topItems: 10,
                offset: 1,
                options: {},
                headers: [
                    {text: "Colaborador", value: "namePerson", sortable: true, width: "20%" },
                    {text: "Painel", value: "painelNegocios", align: 'center', sortable: false},
                    {text: "Produtos", value: "produtosPrevisul", align: 'center', sortable: false},
                    {text: "Cota+", value: "cotaMais", align: 'center', sortable: false},
                    {text: "Movimentação vidas", value: "movVidas", align: 'center', sortable: false},
                    {text: "Arquivos DFI", value: "arquivosDfi", align: 'center', sortable: false},
                    {text: "Arquivos SQG", value: "arquivosSqg", align: 'center', sortable: false},
                    {text: "Arquivos Prestamista", value: "arquivosPrestamista", align: 'center', sortable: false},
                    {text: "Segunda via", value: "segundaVia", align: 'center', sortable: false},
                    {text: "Relatórios", value: "relatorios", align: 'center', sortable: false},
                    {text: "Sinistro", value: "sinistro", align: 'center', sortable: false},
                    {text: "Ajuda", value: "ajuda", align: 'center', sortable: false},
                    {text: "Informes fiscais", value: "informesFiscais", align: 'center', sortable: false},
                    {text: "Comissões", value: "comissoes", align: 'center', sortable: false},
                    {text: "Sou + Previsul", value: "souMaisPrevisul", align: 'center', sortable: false},
                    // {text: "Colaboradores", value: "colaboradores", align: 'center', sortable: false},
                    {text: "Processos Judiciais", value: "processosJudiciais", align: 'center', sortable: false},
                    {text: "", value: "opcoes", sortable: false, width: "10%" }
                ],
                membros: [],
                grupos: [],
                permissoes: [],
                dialog: false,
                tituloDialog: "Atenção",
                textoDialog: "",
                dialogMaxWidth: 450,
                botaoInativar: false,
                botaoAtivar: false,
                botaoLimpar: false,
                botaoConcederAcesso: false,
                botaoCancelar: true,
                dialogCardTexto: false,
                dialogCardMembro: false,
                itemAtual: {},
                membro: { },
                CPFMask: '###.###.###-##',
                telefoneMask:'(##)####-####',
                susepMask : '##.#######.#',
                CepMask: '#####-###',
                date: new Date().toISOString().substr(0, 10),
                menu2: false,
                dadosEnvioMensagens:{
                    guid: null,
                    personId: '',
                    applicationId: '',
                    codigoCorretor: 0,
                    tipoUsuario: 1,
                    nomeContato: '',
                    telefoneContato: '',
                    emailContato: '',
                    tipoNotificacao: 1,
                    receberEmissaoApolice: false,
                },
                rules: {
                    required: value => !!value || 'Obrigatório',
                    mailAddress: value => this.validEmail(value) || 'Utilize um e-mail válido.',
                    CPFValido: value => this.isCpf(value.replace('-', '').split('.').join('')) || 'CPF inválido',
                    celularValido: value => (value || '').length > 13 || 'Celular invalido',
                },                                   
            }
        },
        methods: {
            carregarRoleClaims() {
                this.loading = true;
                this.fullLoading = true;
                Vue.prototype.$httpIdentityServerApi.get(
                    `RoleClaim/my-registers?roleId=${this.usuario.childRoleId}&page=1&pageSize=999`,
                    { headers: { "content-type": "application/json" } }
                ).then(res => {
                    let _response = res.data.data;
                    console.log("carregarRoleClaims > _response");
                    console.log(_response);
                    for(let index in _response)
                    {
                        this.headers.push({text: _response[index].claimValue, value: _response[index].claimType, align: 'center', sortable: false});
                    }
                    this.headers.push({text: "", value: "opcoes", sortable: false, width: "8%" });
                    
                    this.loading = false;
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });                     
            },

            mudarGrupo(item){
                this.loading = true;
                this.fullLoading = true;                
                let roleClaim = [];
                for (let i in this.grupos)
                {
                    if (item.userClaims[0].claimType == this.grupos[i].claimType)
                    {
                        roleClaim.push(this.grupos[i]);
                    }                 
                }

                let userRole = {
                    id: item.id,
                    roleId: item.roleId,
                    userId: item.userId,
                    userParentId: item.userParentId,
                    personId: this.usuario.personId,
                    code: item.code,
                    roleClaims: roleClaim
                };                  

                this.$httpIdentityServerApi.post("userRole", userRole, {
                        headers: { "content-type": "application/json" }
                }).then(response => {
                    this.loading = false;
                    this.fullLoading = false;             
                }).catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                }); 
            },

            membrosCadastroUnico()
            {
                this.loading = true;
                this.fullLoading = true;
                let val = this.usuario.userId;
                let codigoCorretor = this.usuario.codCorretor;

                Vue.prototype.$httpIdentityServerApi.get(`UserRole/my-child-registers/${val}/${codigoCorretor}`,
                    { 
                        headers: { 
                            "content-type": "application/json" 
                        } 
                    }
                ).then(res => {
                    this.membros = res.data.data;
                    console.log("this.membros");
                    console.log(this.membros);
                    for(let index in this.membros)
                    {
                        let roleClaims =  this.membros[index].roleClaims;

                        for(let subIndex in roleClaims)
                        {
                            if ((roleClaims[subIndex].claimType.indexOf('painel') > -1 || roleClaims[subIndex].claimType == 'painel')) 
                            { this.membros[index].painelNegocios =  roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("produtos") > -1 || roleClaims[subIndex].claimType == "produtos") 
                            { this.membros[index].produtosPrevisul = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("cota-mais") > -1 || roleClaims[subIndex].claimType == "cota-mais")
                            { this.membros[index].cotaMais = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("movimentacao-vidas") > -1 || roleClaims[subIndex].claimType == "movimentacao-vidas")
                            { this.membros[index].movVidas = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("processamento-arquivos-dfi") > -1 || roleClaims[subIndex].claimType == "processamento-arquivos-dfi")
                            { this.membros[index].arquivosDfi = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("processamento-arquivos-sqg") > -1 || roleClaims[subIndex].claimType == "processamento-arquivos-sqg")
                            { this.membros[index].arquivosSqg = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("processamento-arquivos-prestamista") > -1 || roleClaims[subIndex].claimType == "processamento-arquivos-prestamista")
                            { this.membros[index].arquivosPrestamista = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("segunda-via") > -1 || roleClaims[subIndex].claimType == "segunda-via")
                            { this.membros[index].segundaVia = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("relatorios") > -1 || roleClaims[subIndex].claimType == "relatorios")
                            { this.membros[index].relatorios = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("sinistro") > -1 || roleClaims[subIndex].claimType == "sinistro")
                            { this.membros[index].sinistro = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("ajuda") > -1 || roleClaims[subIndex].claimType == "ajuda")
                            { this.membros[index].ajuda = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("informes-fiscais") > -1 || roleClaims[subIndex].claimType == "informes-fiscais")
                            { this.membros[index].informesFiscais = roleClaims[subIndex]; }

                            if(roleClaims[subIndex].claimType.indexOf("comissoes") > -1 || roleClaims[subIndex].claimType == "comissoes")
                            { this.membros[index].comissoes = roleClaims[subIndex]; } 

                            if(roleClaims[subIndex].claimType.indexOf("sou-mais-previsul") > -1 || roleClaims[subIndex].claimType == "sou-mais-previsul")
                            { this.membros[index].souMaisPrevisul = roleClaims[subIndex]; }

                            if( roleClaims[subIndex].claimType.indexOf("processos-judiciais") > -1 || roleClaims[subIndex].claimType == "processos-judiciais")
                            { this.membros[index].processosJudiciais = roleClaims[subIndex]; }

                        }
                    }
                    
                    this.loading = false;
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });                 
            },

            pesquisar(){
                this.offset = 1
                this.membrosCadastroUnico()
            },

            novoMembro(){
                this.membro = 
                {
                    id: 0,
                    name: "",
                    type: "F",
                    register: "",
                    birth: null,
                    sex: "",
                    address: null,
                    number: null,
                    complement: null,
                    location: null,
                    zipCode: null,
                    city: null,
                    uf: null,
                    email:null,
                    phoneContact: null
                },
                this.limparDialog();
                this.dialogMaxWidth = 900;
                this.dialogCardMembro = true;
                this.botaoCancelar = false;
                this.tituloDialog = "Novo Colaborador";
                this.dialog = true;
            },

            detalhesMembro(item){
                this.limparDialog();
                                
                let id = item.id;
                Vue.prototype.$httpIdentityServerApi.get(
                    `UserRole/user-role-person/${id}`, { headers: { "content-type": "application/json" } }
                ).then(res => {
                    this.membro = res.data;
                    this.membro.dataNasc = this.FormatarData(this.membro.birth);
                    this.AtualizarMascaraTelefone();
                    this.loading = false;
                    this.fullLoading = false;
                    this.botaoLimpar = true;
                    this.dialogMaxWidth = 900;
                    this.dialogCardMembro = true;
                    this.botaoCancelar = false;
                    this.tituloDialog = "Novo Colaborador";
                    this.dialog = true;

                    this.requestEnvioMensagem(res.data.personId, 1);
                })
                .catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });
            },

            requestEnvioMensagem(personId, applicationId) {
                let codigoCorretor = this.usuario.codCorretor;
                let url = "EnvioMensagem/" + codigoCorretor + "/" + personId + "/" + applicationId;

                // Request envio mensagens
                Vue.prototype.$httpPortal.get(url).then()
                .then(res => {
                    console.log(res.data);
                    this.dadosEnvioMensagens = res.data;
                })
                .catch(ex => {
                    console.log(ex);
                });        
            },

            cadastrarEnvioMensagem(personId){
                let data = {
                    nomeContato: this.membro.name,
                    telefoneContato: this.membro.phoneContact,
                    emailContato: this.membro.email,
                    personId: personId,
                    loginId: 0,
                    codigoCorretor: this.usuario.codCorretor,
                    applicationId: 1,
                    receberEmissaoApolice: this.dadosEnvioMensagens.receberEmissaoApolice
                };

                let url = "EnvioMensagem";                 
                Vue.prototype.$httpPortal.post(url, data).then()
                .then(res => {
                    console.log(res.data);
                })
                .catch(ex => {
                    console.log(ex);
                    this.showToast("error", "Erro", "Problema ao cadastrar envio de mensagens!");
                });                    

            },

            atualizarEnvioMensagem(){
                this.dadosEnvioMensagens.nomeContato = this.membro.name;
                this.dadosEnvioMensagens.loginId = 0;
                this.dadosEnvioMensagens.telefoneContato = this.membro.phoneContact;
                this.dadosEnvioMensagens.emailContato = this.membro.email;
                let url = "EnvioMensagem";                 
                Vue.prototype.$httpPortal.put(url, this.dadosEnvioMensagens).then()
                .then(res => {
                    console.log(res.data);
                })
                .catch(ex => {
                    console.log(ex);
                    this.showToast("error", "Erro", "Problema ao cadastrar envio de mensagens!");
                });                    

            },

            limparDialog()
            {
                this.date = new Date().toISOString().substr(0, 10);
                this.botaoInativar = false;
                this.botaoAtivar = false;
                this.textoDialog = "";
                this.botaoLimpar = false;
                this.dialogCardTexto = false;
                this.dialogCardMembro = false;  
                this.botaoConcederAcesso = false;
                this.dialogMaxWidth = 450; 
                this.tituloDialog = "Atenção";    
                this.botaoCancelar = true;         
                this.dialog = false;
            },

            dialogInativarMembro(item)
            {
                this.limparDialog();
                this.itemAtual = item;
                this.dialogCardTexto = true;
                this.botaoInativar = true;
                this.textoDialog = `Deseja realmente INATIVAR o colaborador ${item.namePerson} ? `;
                this.dialog = true;
            },

            dialogAtivarMembro(item)
            {
                this.limparDialog();
                this.itemAtual = item;
                this.dialogCardTexto = true;
                this.botaoAtivar = true;
                this.textoDialog = `Deseja realmente ATIVAR o colaborador ${item.namePerson} ? `;
                this.dialog = true;                
            },

            alterarStatusMembro(status)
            {
                this.fullLoading = true;
                let _user = 
                {
                    id : this.itemAtual.id,
                    active: status
                };

                this.$httpIdentityServerApi.put("userRole", _user, {
                        headers: { "content-type": "application/json" }
                }).then(response => {
                    this.fullLoading = false;
                    this.limparDialog();

                    let mensagemToast = status ? `Colaborador ${this.itemAtual.namePerson} está ativado` : `Colaborador ${this.itemAtual.namePerson} está inativado`;

                    this.showToast("success", "Sucesso", mensagemToast);
                    this.membrosCadastroUnico();             
                }).catch(ex => {
                    console.log(ex);
                    this.limparDialog();
                    this.fullLoading = false;
                }); 
            },

            alterarRoleClaimNovo(claimType, userRoleId)
            {
                
                if (claimType !== undefined)
                {
                    this.fullLoading = true;
                    let _userRoleClaim = 
                    {
                        userRoleId : userRoleId,
                        claimType : claimType

                    };

                    this.$httpIdentityServerApi.post("userRoleClaim", _userRoleClaim, {
                            headers: { "content-type": "application/json" }
                    }).then(response => {
                        this.fullLoading = false;
                        this.limparDialog();

                        this.membrosCadastroUnico();             
                    }).catch(ex => {
                        console.log(ex);
                        this.limparDialog();
                        this.fullLoading = false;
                    }); 
                }
            },

            alterarRoleClaim(item, userRoleId)
            {
                
                if (item !== undefined)
                {
                    this.fullLoading = true;
                    let _userRoleClaim = 
                    {
                        id : item.id,
                        userRoleId : userRoleId,
                        RoleClaimId : item.roleClaimId
                    };

                    this.$httpIdentityServerApi.put("userRoleClaim", _userRoleClaim, {
                            headers: { "content-type": "application/json" }
                    }).then(response => {
                        this.fullLoading = false;
                        this.limparDialog();

                        this.membrosCadastroUnico();             
                    }).catch(ex => {
                        console.log(ex);
                        this.limparDialog();
                        this.fullLoading = false;
                    }); 
                }
            }, 

            FormatarNascimento()
            {
                if(this.membro.personId !== undefined)
                {
                    this.membro.dataNasc = this.FormatarData(this.membro.birth);
                }
            },

            validEmail(email) {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                console.log("validEmail");
                return re.test(email);
            },   

            AtualizarMascaraTelefone()
            {
                if(this.membro.phoneContact != null && this.membro.phoneContact.length > 13)
                {
                    this.telefoneMask = '(##)#####-####';
                }
                else
                {
                    this.telefoneMask = '(##)####-####'; 
                }
            },

            BuscarCep()
            {
                if (this.membro.zipCode.replace('-', '').length == 8)
                {
                    this.fullLoading = true;                    

                    this.obterEndereco(this.membro.zipCode).then(response => {
                        const _endereco = response.data.data;
                        console.log(_endereco);

                        this.membro.address = _endereco.Logradouro;
                        this.membro.city = _endereco.Localidade;
                        this.membro.location = _endereco.Bairro;
                        this.membro.uf = _endereco.UF;
                        this.fullLoading = false;                    
                    }).catch(ex => {
                        this.fullLoading = false;
                    });
                }
            },

            saveCollaborator(scope)
            {
                let novoCadastro = false;
                if(this.$refs.formCollaborator.validate())
                {
                    this.fullLoading = true;
                    let person = 
                    {
                        id: this.membro.personId !== undefined ? this.membro.personId : 0,
                        code: this.membro.personCode !== undefined ? this.membro.personCode : null,
                        name: this.membro.name,
                        type: "F",
                        register: this.membro.register,
                        birthText: this.membro.dataNasc,
                        sex: this.membro.sex,
                        address: this.membro.address,
                        number: this.membro.number,
                        complement: this.membro.complement,
                        location:this.membro.location,
                        zipCode: this.membro.zipCode,
                        city: this.membro.city,
                        uf:this.membro.uf,
                        email: this.membro.email,
                        phoneContact: this.membro.phoneContact,
                        isWhatsApp: false,
                        active: this.membro.personActive !== undefined ? false : this.membro.personActive
                    };

                    if(this.membro.personId === undefined)
                        novoCadastro = true;                  

                    this.$httpIdentityServerApi.post("person", person, {
                        headers: { 
                            "content-type": "application/json" 
                        }
                    }).then(response => {
                        let personId = response.data.data.id;

                        if (personId != 0) {
                            this.saveUser(personId);
                            if(novoCadastro == true) {
                                this.cadastrarEnvioMensagem(personId);
                            }
                            else {
                                this.atualizarEnvioMensagem();
                            }                            
                        } 
                        else {
                            
                            for(let index in response.data.data.errors) {
                                this.showToast("error", "Erro", response.data.data.errors[index].description);
                            }
                            this.membro.register = "";
                            this.loading = false;
                            this.fullLoading = false;                            
                        }
                    }).catch(ex => {
                        console.log(ex);
                        this.limparDialog(); 
                        this.showToast("error", "Erro", "Ocorreu um problema ao salvar.Tente novamente.");
                        this.loading = false;
                        this.fullLoading = false;
                    });                     

                }
            },

            saveUser(personId)
            {
                let user = {
                    id: this.membro.userId !== undefined ? this.membro.userId : 0,
                    code: this.membro.userCode !== undefined ? this.membro.userCode : null, 
                    userName: this.membro.email,
                    phoneNumber: this.membro.phoneContact,
                    cpf: this.membro.register,
                    name: this.membro.name,
                };

                this.$httpIdentityServerApi.post("user", user, {
                    headers: { 
                        "content-type": "application/json" 
                    }
                }).then(response => {
                    let userId = response.data.data.id;
                    this.saveUserRole(personId, userId);             
                }).catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                    this.limparDialog(); 
                    this.showToast("error", "Erro", "Ocorreu um problema ao salvar.Tente novamente.");                    
                });                                 
            },

            saveUserRole(personId, userId)
            {
                let parentId = this.usuario.userId;
                let childRoleId = this.usuario.childRoleId;
                this.membro.code = this.usuario.codCorretor != null ? this.usuario.codCorretor:null;
                
                let userRole = JSON.parse(JSON.stringify({
                    id : this.membro.id !== undefined ? this.membro.id : 0,
                    roleId: parseInt(childRoleId),
                    userId: userId,
                    userParentId: parseInt(parentId),
                    personId: parseInt(this.usuario.personId),
                    code: this.membro.code,
                    active: this.membro.active
                }));
                
                console.log("userRole", userRole);            

                this.$httpIdentityServerApi.post("userRole", userRole, {
                    headers: { 
                        "content-type": "application/json" 
                    }
                }).then(response => {
                    this.loading = false;
                    this.fullLoading = false;
                    let mensagemToast = this.membro.id != 0 ? "Colaborador atualizado com sucesso!" : "Colaborador cadastrado com sucesso!";
                    this.showToast("success", "Sucesso", mensagemToast);   
                    this.limparDialog(); 
                    this.membrosCadastroUnico();         
                }).catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                    this.limparDialog(); 
                    this.showToast("error", "Erro", "Ocorreu um problema ao salvar.Tente novamente.");                    
                });                 
            },

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },

            parseDate (date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },

            ColaboradorExiste(scope)
            {
                if(this.$refs.formCollaborator.validate())
                {
                    this.fullLoading = true;

                    let novoCadastro = false;
                    if(this.membro.personId === undefined)
                        novoCadastro = true;                      

                    if(novoCadastro == true)
                    {
                        let personConfirmDto = 
                        {
                            userParentId: parseInt(this.usuario.userId),
                            register: this.membro.register,
                            email: this.membro.email,
                            code: this.usuario.codCorretor
                        };               
                        
                        console.log("personConfirmDto", personConfirmDto);

                        this.$httpIdentityServerApi.post("person/confirm-exist", personConfirmDto, {
                            headers: { 
                                "content-type": "application/json" 
                            }
                        }).then(response => {
                            let _userRole = response.data.data.userRole;
                            
                            if(_userRole != undefined) {
                                this.fullLoading = false;
                                this.colaboradorUserRole = _userRole;
                                this.botaoConcederAcesso = true;
                                this.botaoCancelar = true;
                                this.dialogCardMembro = false;
                                this.dialogCardTexto = true;
                                this.tituloDialog = "Atenção";
                                this.textoDialog = "Este usuário já existe no sistema. Deseja conceder acesso ao Portal do Corretor?";
                            } 
                            else {
                                let _cadastrar = true;
                                if(response.data.data.errors)    
                                {
                                    for(let index in response.data.data.errors)
                                    {
                                        if (response.data.data.errors[index].key != "0")
                                        {
                                            this.loading = false;
                                            this.fullLoading = false;                                            
                                            _cadastrar = false;
                                            this.showToast("error", "Erro", response.data.data.errors[index].description);
                                        }
                                    }
                                                                    
                                }
                                
                                if(_cadastrar == true)
                                {
                                    console.log("ColaboradorExiste > this.saveCollaborator(scope);")
                                    this.saveCollaborator(scope);
                                }                                
                            }
                        }).catch(ex => {
                            console.log(ex);
                            this.limparDialog(); 
                            this.showToast("error", "Erro", "Ocorreu um problema. Tente novamente.");
                            this.loading = false;
                            this.fullLoading = false;
                        });                                             
                    }

                    if(novoCadastro == false)
                    {
                        this.saveCollaborator(scope);
                    }
                }                                    
            },

            concederAcesso()
            {
                this.fullLoading = true;

                if(Object.keys(this.colaboradorUserRole).length > 0)
                {
                    let userRole = JSON.parse(JSON.stringify({
                        id : 0,
                        roleId: parseInt(this.usuario.childRoleId),
                        userId: parseInt(this.colaboradorUserRole.userId),
                        userParentId: parseInt(this.colaboradorUserRole.userParentId),
                        personId: parseInt(this.usuario.personId),
                        code: this.usuario.codCorretor,
                        active: this.colaboradorUserRole.active
                    })); 

                    console.log('userRole', userRole);
                    
                    this.$httpIdentityServerApi.post("userRole", userRole, {
                        headers: { 
                            "content-type": "application/json" 
                        }
                    }).then(_ => {
                        this.loading = false;
                        this.fullLoading = false;
                        let mensagemToast = "Colaborador cadastrado com sucesso!";
                        this.showToast("success", "Sucesso", mensagemToast);   
                        this.limparDialog(); 
                        this.membrosCadastroUnico();         
                    }).catch(ex => {
                        console.log(ex);
                        this.loading = false;
                        this.fullLoading = false;
                        this.limparDialog(); 
                        this.showToast("error", "Erro", "Ocorreu um problema ao salvar.Tente novamente.");                    
                    });                      

                }   
            }                                    
        },

        computed: {
            ...mapGetters("static", ["getStatic"]),
            ...mapGetters("usuarioModule", { usuario: "getUserInfo" }), 
            
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
        },

        watch: {
            date (val) {
                this.membro.dataNasc = this.formatDate(this.date)
            },
        },  

        filters: {
            formatDateBR(value){
                if (value) {
                    return moment(String(value)).format('DD/MM/YYYY');
                }
            }
        },

        mounted(){            
            this.membrosCadastroUnico();
        },
    }
</script>
